import { useContext } from 'react';

import { AppConfigContext } from 'components/Contexts';

export const useAppConfig = () => useContext(AppConfigContext);
